import { createBrowserRouter } from 'react-router-dom';
import { RootLayout } from './layouts/RootLayout';

// Lazy-load pages for code splitting
import HomePage from './pages/Home';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import EmailDocumentsPage from './pages/campaigns/EmailDocuments';
import EmailBuilderPage from './pages/campaigns/EmailBuilder';
import TemplatesPage from './pages/campaigns/Templates';
import EmailCampaignsPage from './pages/campaigns/EmailCampaigns';
import CampaignWizardPage from './pages/campaigns/CampaignWizard';
import CampaignDetailPage from './pages/campaigns/CampaignDetail';
import ContactsPage from './pages/audience/ContactsPage';
import ContactDetailPage from './pages/audience/ContactDetailPage';
import ContactAttributeDefinitionsPage from './pages/audience/ContactAttributeDefinitionsPage';
import ListsPage from './pages/audience/ListsPage';
import ListDetailPage from './pages/audience/ListDetailPage';
import SettingsPage from './pages/settings/SettingsPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'register',
        element: <RegisterPage />,
      },
      {
        path: 'campaigns',
        children: [
          {
            index: true,
            element: <EmailCampaignsPage />,
          },
          {
            path: 'new',
            element: <CampaignWizardPage />,
          },
          {
            path: ':campaignId',
            element: <CampaignDetailPage />,
          },
          {
            path: 'email',
            element: <EmailDocumentsPage />,
          },
          {
            path: 'email/:id',
            element: <EmailBuilderPage />,
          },
          {
            path: 'templates',
            element: <TemplatesPage />,
          },
        ],
      },
      {
        path: 'audience',
        children: [
          {
            path: 'contacts',
            element: <ContactsPage />,
          },
          {
            path: 'contacts/:contactId',
            element: <ContactDetailPage />,
          },
          {
            path: 'contact-attributes',
            element: <ContactAttributeDefinitionsPage />,
          },
          {
            path: 'lists',
            element: <ListsPage />,
          },
          {
            path: 'lists/:listId',
            element: <ListDetailPage />,
          },
        ],
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
    ],
  },
]);
